import { useMutation, useQueryClient } from '@tanstack/react-query';
import { medicalRecordsApi, type DiagnosisType } from '@/api';

export function useCreateDiagnosis() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      medicalRecordId: string;
      cidCode?: string;
      description: string;
      type: DiagnosisType;
    }) => medicalRecordsApi.createDiagnosis(data),
    onSuccess: (newDiagnosis) => {
      queryClient.invalidateQueries({
        queryKey: ['medical-records', 'record', newDiagnosis.medicalRecordId],
      });
    },
  });
}
